<template>
  <div class="pb-1">
    <div :class="{'hidden': isSuccess}">
      <b-card v-if="Boolean(marketcenter)">
        <div class="mb-1">
          <router-link class="lnk link-primary" :to="{ name: 'marketcenter' }">
            <feather-icon icon="ChevronLeftIcon" size="18"/>
          </router-link>
        </div>
        <div class="row justify-content-md-between px-1">
          <div>
            <img :src="marketcenter.icon" alt="logo integration" width="115px">
            <span class="text-warning ml-1">{{edit ? 'Edita tu configuración de Marketcenter' : 'Conecta tu negocio al canal de ventas'}}</span>
          </div>
          <div class="d-flex align-items-center">
            <feather-icon icon="SettingsIcon" size="14" style="color:#044389"/>&nbsp;<a @click="goRedirect(marketcenter.documentation)" style="color:#044389;font-size:8px;font-weight:bolder;">GUÍA DE CONFIGURACIÓN</a>
          </div>
        </div>
        <div class="border-top"></div>
        <div v-if="!edit">
          <div class="py-2" v-if="matchesIntegrationCode">
            <card-item>
              <div class="spacing">
                <span class="text-primary title">Paso 1</span>
                &nbsp;<span class="text-primary" style="font-size:16px">
                  Redirige a tu cuenta de
                  <span v-if="marketcenter.code.startsWith('MV')">Multivende</span>
                  <span v-else>Mercado Libre</span>
                  para iniciar la configuración.
                </span>
                <b-button v-if="!marketcenter.is_integrated" variant="outline-warning ml-1"
                  @click="goRedirectIntegration()">
                  IR A {{ marketcenter.code.startsWith('MV') ? 'MULTIVENDE' : 'MERCADO LIBRE' }}
                </b-button>
              </div>
              <div class="border-top"></div>
              <div class="spacing">
                <ul>
                  <li>
                    Haz clic en el botón
                    <b class="text-primary">
                      'Ir a {{ marketcenter.code.startsWith('MV') ? 'Multivende' : 'Mercado Libre' }}'
                    </b>
                    para ser redirigido a la página de inicio de sesión de
                    {{ marketcenter.code.startsWith('MV') ? 'Multivende' : 'Mercado Libre' }}.
                    Inicia sesión con tu usuario y contraseña de administrador.
                    Una vez que hayas iniciado sesión, autoriza a Envíame para conectarse con tu cuenta de
                    {{ marketcenter.code.startsWith('MV') ? 'Multivende' : 'Mercado Libre' }}.
                  </li>
                  <li>
                    Después de autorizar, regresa a esta página y selecciona el botón
                    <b class="text-primary">'Validar Autenticación'</b> para completar la configuración de la
                    integración.
                  </li>
                </ul>
              </div>
            </card-item>
            <div class="d-flex justify-content-end mt-4">
              <div class="d-flex align-items-center">
                <span>Utiliza el botón <b class="text-primary">'Validar Autenticación'</b> para finalizar la integración.</span>
              </div>
              <div>
                <b-button class="ml-1" variant="warning" :disabled="!marketcenter.is_integrated" @click="goSuccessView">VALIDAR AUTENTICACION</b-button>
              </div>
            </div>
          </div>
          <div class="py-2" v-if="!matchesIntegrationCode">
            <card-item>
              <div class="spacing">
                <span class="text-primary title">Paso 1</span>
                &nbsp;<span class="text-primary" style="font-size:16px">Configura los selectores eligiendo las opciones correspondientes.</span>
              </div>
              <div class="border-top"></div>
              <div class="spacing" v-if="!loading.fields">
                <ul>
                  <li v-for="item in filterCustomization" :key="item.field">
                    <b>{{item.label}}:</b>&nbsp;{{item.description}}
                  </li>
                </ul>
                <div class="mt-2">
                  <form-render
                    :form.sync="form"
                    :key="keyformIntegration"
                    :fields="fields"
                    ref="keyformIntegration"
                    containerButtonsClass="col-sm-12 col-md-7 col-lg-4 col-xl-3 container-button mt-2" class="mb-2">
                  </form-render>
                </div>
              </div>
              <div v-if="loading.fields" class="d-flex justify-content-center align-items-center" style="min-height:14em">
                <b-spinner variant="primary"></b-spinner>
              </div>
            </card-item>
            <div class="d-flex justify-content-end">
              <div>
                <b-button class="mt-4" variant="warning" @click="postMarketcenter" :disabled="loading.post">
                  <b-spinner v-show="loading.post" small></b-spinner>&nbsp;CONECTAR</b-button>
              </div>
            </div>
          </div>
        </div>
        <div v-if="edit" class="py-2">
          <card-item>
              <div class="spacing">
                <span class="text-primary title">Paso 1</span>
                &nbsp;<span class="text-primary" style="font-size:16px">Ajusta y completa los campos de información que consideres pertinente.</span>
              </div>
              <div class="border-top"></div>
              <ul class="m-1" v-if="isMeliIntegration">
                  <li class="text-primary li--info-text-meli" style="font-size:14px">A continuación, puedes visualizar los modos de envío disponibles y activos en Mercado Libre. Si no encuentras un modo de envío en la lista, deberás solicitar su activación directamente con Mercado Libre.</li>
              </ul>
              <div class="spacing pt-2" v-if="!loading.fields">
                <form-render
                  id="editForm"
                  :form.sync="form"
                  :key="keyEditFormIntegration"
                  :fields="fields"
                  ref="keyEditFormIntegration"
                  containerButtonsClass="col-sm-12 col-md-7 col-lg-4 col-xl-3 container-button mt-2" class="mb-2">
                </form-render>
              </div>
              <div v-if="loading.fields" class="d-flex justify-content-center align-items-center" style="min-height:31em">
                <b-spinner variant="primary"></b-spinner>
              </div>
            </card-item>
            <div class="mt-3 d-flex justify-content-end">
              <b-button variant="outline-warning mr-1" @click="goMarketcenter">CANCELAR</b-button>
              <b-button v-if="!viewButtonEdit" variant="warning" @click="postMarketcenter" :disabled="loading.post"><b-spinner v-show="loading.post" small></b-spinner>&nbsp;GUARDAR CAMBIOS</b-button>
              <b-button v-if="viewButtonEdit" @click="onHandleEdit" variant="warning">&nbsp;EDITAR</b-button>
            </div>
        </div>
      </b-card>
    </div>
    <div :class="{'hidden': !isSuccess}">
      <b-card>
        <div class="mt-3" >
          <div class="d-flex justify-content-center align-items-center">
            <span class="ml-1 text-center"><img style="width: 80%;" src="@/assets/images/login/Logos-grandes.png" alt="Logo Meli"></span>
          </div>
          <div class="text-center mt-3">
            <span style="font-size:24px;font-weight:bold"><feather-icon icon="CheckCircleIcon" size="24" class="text-success"/> ¡Integración exitosa!</span>
          </div>
          <div class="d-flex justify-content-center mt-2">
            <span class="w-60">Para ver el detalle de la integración, te recomendamos ingresar a la configuración del canal de venta. Revísalo y, si es necesario, personaliza los datos predeterminados proporcionados por Mercado Libre.</span>
          </div>
          <div class="d-flex justify-content-center mt-3" style="margin-bottom:15%">
            <b-button class="mr-2" variant="outline-warning" style="width:250px" @click="goEdit">IR A LA CONFIGURACIÓN</b-button>
            <b-button variant="warning" style="width:250px" @click="goMarketcenter">IR AL INICIO</b-button>
          </div>
        </div>
      </b-card>
    </div>
  </div>
</template>
<script>
import environment from '@/environments/environment'
import { mapGetters } from 'vuex'
import CardItem from '../components/CardItem.vue'
export default {
  components: { CardItem },
  data() {
    return {
      keyformIntegration: 0,
      keyEditFormIntegration: 0,
      isSuccess: false,
      form: {},
      fields: [],
      viewButtonEdit: true,
      loading: {
        fields: false,
        post: false
      },
      backupFields: Object.freeze({
        flb: {
          api_key_falabella: {
            config: true,
            description: 'Importa la "API Key" que has copiado en el campo "API Key" desde la pestaña API de tu cuenta de SellerCenter de Falabella.'
          },
          user_id: {
            config: true,
            description: 'Importa el correo que has copiado en el campo "User ID" desde la pestaña API de tu cuenta de SellerCenter de Falabella.'
          }
        },
        daf: {
          application_id: {
            config: true,
            description: 'Importa la "Application ID" que has copiado en el campo "Application ID" desde la pestaña OAuth Applications de tu cuenta de SellerCenter de Dafiti.'
          },
          application_secret: {
            config: true,
            description: 'Importa la "Application Secret" que has copiado en el campo "Application Secret" desde la pestaña OAuth Applications de tu cuenta de SellerCenter de Dafiti.'
          }
        },
        prm: {
          seller_shipper_id: {
            config: true,
            description: 'Importa el "ID" que has copiado en el campo "ID" desde la pestaña Info. de la empresa de tu cuenta Seller asociada a la cuenta de Cencosud en Envíame.'
          }
        },
        rpl: {
          username: {
            config: true,
            description: 'Importa el correo que has copiado en el campo "Nombre de Usuario" desde tu cuenta de SellerCenter de Ripley.'
          },
          password: {
            config: true,
            description: 'Importa la contraseña que has copiado en el campo "Contraseña" desde tu cuenta de SellerCenter de Ripley.'
          }
        },
        hts: {
          seller_shipper_id: {
            config: true,
            description: 'Importa el "ID" que has copiado en el campo "ID" desde la pestaña Info. de la empresa de tu cuenta Seller asociada a la cuenta de Envíame.'
          }
        },
        kc: {
          seller_shipper_id: {
            config: true,
            description: 'Importa el "ID" que has copiado en el campo "ID" desde la pestaña Info. de la empresa de tu cuenta Seller asociada a la cuenta de Envíame.'
          }
        },
        wm: {
          seller_shipper_id: {
            config: true,
            description: 'Importa el "ID" que has copiado en el campo "ID" desde la pestaña Info. de la empresa de tu cuenta Seller asociada a la cuenta de Envíame.'
          }
        },
        mv: {
          api_key_enviame: {
            config: true,
            description: 'Ingresa la API Key de tu cuenta de Multivende.'
          }
        }
      }),
      obj_alert_info: {
        svg: 'info.svg', 
        title: 'Flete Dinámico y Mercado Envíos 1 [ME1]',
        textParts: [
          { text: 'Para que tus órdenes se procesen correctamente con el modo de envío Mercado Envíos 1 [ME1], ' },
          { text: 'primero debes habilitar Flete Dinámico', strong: '500' },
          { text: '. Una vez activado, Mercado Libre validará y confirmará la activación de esta modalidad.' }
        ],
        classTitle: 'text-custom-alert-h4',
        classText: 'text-custom-alert-p',
        classContainer: 'alert-custom',
        classSvg: 'img-custom-alert'
      },
      dynamicShippingConfig: {
        deliveryMode: {
          id: 'me1',
          text: 'Mercado Envíos 1 [M1]'
        },
        logisticType: {
          id: 'default',
          text: '[ME1] Mercado Default',
          parent: 'me1'
        }
      },
      conditions: Object.freeze({
        mv: 'multivende',
        ml: 'mercado-libre'
      })
    }
  },
  computed: {
    ...mapGetters({
      mySession: 'getSession',
      organizations: 'getOrganizations',
      shippersByOrganization: 'getShippersByOrganization',
      generalLoading: 'getLoading',
      marketcenters: 'getMarketcenters',
      warehouses: 'getWarehouses',
      fieldsMarketcenter: 'getFieldsMarketcenter',
      paramsMkc: 'getParamsMkc',
      fieldsMeli: 'getFieldsMeli'
    }),
    shipper_id() {
      return this.$route.params.shipper_id
    },
    isMeliCode () {
      return this.format_marketcenter_code === 'ml'
    },
    format_marketcenter_code () {
      return this.marketcenter_code.split('_')[0].toLowerCase()
    },
    marketcenter_code() {
      return this.$route.params.marketcenter_code
    },
    marketcenter() {
      return this.marketcenters.find((mkc) => mkc.code === this.marketcenter_code)
    },
    myWarehouses() {
      return this.warehouses?.map((ware) => ({...ware, id: ware.code, text: ware.name}))
    },
    matchesIntegrationCode() {
      const regex = /^(ML|MV)/gm
      return Boolean(this.marketcenter.code.match(regex))
    },
    customization() {
      const customAdd = this.backupFields[this.format_marketcenter_code] ?? {}
      return this.fieldsMarketcenter.map((custom) => ({...custom, ...customAdd[`${custom.field}`]})) ?? []
    },
    filterCustomization() {
      return this.customization.filter((custom) => custom.config) ?? []
    },
    edit() {
      return this.$route.params.edit === 'edit'
    },
    defaultWarehouse() {
      const [warehouse] = this.myWarehouses
      return warehouse
    },
    integrationsRedirectBaseUrl() {
      return environment.environment.ottawaIntegrationsRedirect
    }
  },
  watch: {
    fields() {
      const fields = this.customization
      this.form = fields.reduce((target, key) => {
        const value = this.getValuesForm(key)
        target[key.field] = value
        return target
      }, {})
    },
    'generalLoading': {
      handler () {
        this.loading.fields = !!this.generalLoading.getFieldsMeli || !!this.generalLoading.getFieldsMarketcenter
        this.loading.post = !!this.generalLoading.postConfigMarketcenter
      },
      deep: true
    },
    'form.enable_dynamic': {
      handler(newValue) {
        if (this.isMeliCode) {
          this.toggleM1InDeliveryMode(newValue)
        }
      },
      immediate: true
    }
  },
  mounted() {
    this.getFieldsMarketcenter()
    if (!Boolean(this.marketcenters.length)) this.getMarketcenters()
    if (!Boolean(this.warehouses.length)) this.getWarehouses()
  },
  methods: {
    goRedirectIntegration() {
      const customPrefix = this.conditions[`${this.marketcenter_code.split('_')[0].toLowerCase()}`]
      const api_key = this.customization.find((custom) => custom.field === 'api_key_enviame').value
      const urlIntegration = `${ this.integrationsRedirectBaseUrl}/webhook/${ customPrefix }/authenticate?api_key=${ api_key }&company=${ this.shipper_id }&warehouse_code=${ this.warehouses[0]?.code }&marketcenter_code=${ this.marketcenter_code }`
      window.parent.location.replace(urlIntegration)
    },
    goRedirect(url) {
      window.open(url, '_blank')
    },
    setFieldsIntegration(disabled, fieldsMeli) {
      const fields = fieldsMeli || (this.edit ? this.customization : this.filterCustomization)
      const fieldsDisabled = this.setDisabledMeliFields(fields)
      this.fields = fieldsDisabled.filter((field) => !field?.hidden).map(({field, label, type, ...rest}) => {
        const typeField = this.getCustomizedField(field, label, type, rest)
        return {
          ...typeField,
          name: field,
          containerClass: 'col-lg-4 col-md-5 col-sm-12 container-info',
          validation: this.edit ? rest?.validation : rest?.config ? 'required' : '',
          disabled: disabled ?? Boolean(rest?.disabled)
        }
      }) ?? []
    },
    getCustomizedField (field, label, type, rest) {
      const baseConfig = { label }
      switch (type) {
      case 'checkbox': {
        return this.createCheckboxFieldConfig(field, label)
      }
      case 'select': {
        const options = field === 'warehouse_code' ? this.myWarehouses : rest?.options?.map((op) => ({ id: op.code, text: op.name })) || []
        return { ...baseConfig, fieldType:'FieldSelect', options}
      }
      case 'multiselect': {
        return this.createMultiSelectFieldConfig(field, baseConfig, rest)
      }
      case 'textarea': {
        return {  ...baseConfig, fieldType:'FieldTextarea' }
      }
      default: {
        return { ...baseConfig, fieldType: 'FieldInput' }
      }
      }
    },
    createCheckboxFieldConfig(field, label) {
      let config = {
        fieldType: 'FieldCheckbox',
        options: [{ id: true, text: label }]
      }
      if (this.isMeliCode) {
        config = {
          ...config,
          ...this.createCheckboxFieldMeli(field)
        }
      }
      return config
    },
    createMultiSelectFieldConfig(field, baseConfig, rest = {}) {
      const multiSelectOptions = rest?.options?.map((op) => ({id: op.value, text: op.title, ...(op.parent ? { parent: op.parent } : {})})) || []
      let config = {
        ...baseConfig,
        fieldType: 'FieldSelect',
        options: multiSelectOptions,
        multiple: true
      }
      if (this.isMeliCode) {
        config = {
          ...config,
          ...this.createMultiSelectFieldMeli(field)
        }
      }
      return config
    },
    getValuesForm (key) {
      switch (key.type) {
      case 'checkbox':
        return !!key.value
      case 'select':
        return key.field === 'warehouse_code' ? this.myWarehouses?.find((w) => w.value === key.id) ?? {} : key.options?.map((el) => ({id: el.code, text: el.name}))?.find((w) => w.id === key.value)
      case 'multiselect':
        return key.options.filter((v) => key.value.some((value) => value === v.value)).map((v) => ({id: v.value, text:v.title, ...(v.parent ? { parent: v.parent } : {})})) || []
      case 'textarea':
        return key.value
      default:
        return key.value
      }
    },
    getPostValuesForm (field, form) {
      switch (field.type) {
      case 'checkbox':
        return !!form[field.field]
      case 'select':
        return form[field.field]?.id ?? ''
      case 'multiselect':
        return form[field.field]?.map((v) => v.id) || []
      default:
        return form[field.field] ?? ''
      }
    },
    setDisabledMeliFields(fields) {
      const nameFields = ['api_key_enviame', 'marketcenter_code', 'company_id']
      nameFields.forEach((name) => {
        this.setDisabledFields(fields, name)
      })
      return fields
    },
    setDisabledFields(fields, name) {
      const index = fields.findIndex((field) => field.field === name)
      if (index < 0) return
      fields[index].disabled = true
    },
    async postMarketcenter() {
      const form = this.edit ? this.$refs.keyEditFormIntegration : this.$refs.keyformIntegration
      if (!await form.onlyCheckForm()) return
      const queryParams = this.customization.map((field) => {
        //eliminar cuando este listo el back
        const { config, description, ...payload } = field
        if (!this.edit) this.form.warehouse_code = this.defaultWarehouse
        const newValue = this.getPostValuesForm(field, this.form)
        return {
          ...payload,
          value: newValue
        }
      })
      const data = {
        name: 'postConfigMarketcenter',
        params: {marketcenter_cod: this.marketcenter_code, shipper_id: this.shipper_id},
        queryParams,
        onSuccess: () => {
          this.getMarketcenters()
          this.$router.push({ name: 'marketcenter' })
        }
      }
      this.$store.dispatch('fetchService', data)
    },
    getMarketcenters() {
      this.$store.dispatch('dispatchSetParamsMkc', { ...this.paramsMkc, shipper_id: this.shipper_id, marketcenter_code: this.marketcenter_code })
      const data = {
        name: 'getMarketcenters',
        params: { shipper_id: this.shipper_id }
      }
      this.$store.dispatch('fetchService', data)
    },
    getFieldsMarketcenter() {
      const data = {
        name: 'getFieldsMarketcenter',
        params: {marketcenter_cod: this.marketcenter_code, shipper_id: this.shipper_id},
        onSuccess: () => this.handleFieldIntegration()
      }
      this.$store.dispatch('fetchService', data)
    },
    handleFieldIntegration () {
      if (this.isMeliCode  && this.edit) {
        this.getFieldsMeli()
      } else {
        this.setFieldsIntegration(this.edit ? true : undefined)
      }
    },
    getWarehouses() {
      const data = {
        name: 'getWarehouses',
        params: { shipper_id: this.shipper_id }
      }
      this.$store.dispatch('fetchService', data)
    }, 
    goSuccessView() {
      this.isSuccess = true
    },
    goEdit() {
      this.$router.push({ name: 'marketcenter-detail', params: { shipper_id: this.shipper_id, marketcenter_code: this.marketcenter_code, edit: 'edit' }})
      this.isSuccess = false
    },
    goMarketcenter() {
      this.$router.push({ name: 'marketcenter' })
    },
    onHandleEdit() {
      this.viewButtonEdit = false
      this.setFieldsIntegration()
    },
    /* 
      Nuevo logica para Meli
      Agrupe las funciones que generan los nuevos comportamientos esperados en el formulario de Mercado Libre.
    */
    async getFieldsMeli() {
      const data = { 
        name: 'getFieldsMeli',
        params: {marketcenter_cod: this.marketcenter_code, shipper_id: this.shipper_id},
        onSuccess: () => this.fillLogisticOptions(this.fieldsMeli, this.customization),
        onError: () => this.setFieldsIntegration(this.edit ? true : undefined)
      }
      await this.$store.dispatch('fetchService', data)
    },
    getFieldByName (fields, name, type) {
      return fields.find(field => field[type] === name)
    },
    fillLogisticOptions(logisticsData, fields) {
      const logisticTypeField = this.getFieldByName(fields, 'logistic_type_active', 'field')
      const deliveryModeField = this.getFieldByName(fields, 'delivery_mode', 'field')
      if (!logisticTypeField || !deliveryModeField) return
      logisticTypeField.options = this.generateLogisticTypeOptions(logisticsData)
      deliveryModeField.options = this.generateDeliveryModeOptions(logisticsData)
      this.setFieldsIntegration(this.edit ? true : undefined, fields)
    },
    generateLogisticTypeOptions (logisticsData) {
      return logisticsData.flatMap(logistic => 
        logistic.logistics.map(subLogistic => ({
          title: `[${logistic.code.toUpperCase()}] ${subLogistic.name}${subLogistic.code !== 'default' ? ` [${subLogistic.code}]` : ''}`,
          value: subLogistic.code,
          parent: logistic.code
        }))
      )
    },
    generateDeliveryModeOptions (logisticsData) {
      return logisticsData.map(logistic => ({
        title: this.capitalizeTextInBrackets(logistic.name),
        value: logistic.code
      }))
    },
    capitalizeTextInBrackets(text) {
      return text.replace(/\[(.*?)\]/g, (match) => match.toUpperCase())
    },
    toggleM1InDeliveryMode (newValue) {
      this.$nextTick(() => {
        const deliveryModeContainer = document.querySelector('#delivery_mode .vs__selected-options')
        if (!deliveryModeContainer) return
        deliveryModeContainer.classList.toggle('dynamic-shipping-enabled', !!newValue)
      })
    },
    createCheckboxFieldMeli(field) {
      const isDynamicShipping = field === 'enable_dynamic'
      const isMe1 = this.fieldsMeli.some((item) => item.code === 'me1')
      if (!isDynamicShipping) return {}
      const config = {
        change: this.checkEnableDynamic
      }
      if (!isMe1) {
        config.alert_info = this.obj_alert_info
      }
      return config
    },
    createMultiSelectFieldMeli(field) {
      const config = {
        ...(field === 'delivery_mode' && { deselect: this.deselectDeliveryMode, change: this.selectChildrenOnParentSelection }),
        ...(field === 'logistic_type_active' && { dependency: 'delivery_mode', deselect: this.deselectLogisticTypeActive, change: this.selectParentOnChildSelection })
      }
      return config
    },
    getFieldOptionsByName(fieldName) {
      const field = this.fields.find(field => field.name === fieldName)
      return field ? field.options : []
    },
    getInitialValues(fieldName, children) {
      const field = this.getFieldByName(this.customization, fieldName, 'field')
      if (!field || !Array.isArray(field.value)) return []
      const validIds = new Set(children.map(child => child.id))
      return field.value
        .filter(id => validIds.has(id))
        .map(id => children.find(child => child.id === id))
    },
    selectChildrenOnParentSelection(name, value) {
      if (value.length === 0) return
      const lastSelectedMode = value.slice(-1)[0]
      const logisticOptions = this.getFieldOptionsByName('logistic_type_active')
      const children = logisticOptions.filter(option => option.parent === lastSelectedMode.id)
      const initialValues = this.getInitialValues('logistic_type_active', children)
      const childrenToAdd = initialValues.length > 0 ? initialValues : children
      this.form.logistic_type_active = [
        ...this.form.logistic_type_active.filter(selected => selected.parent !== lastSelectedMode.id),
        ...childrenToAdd
      ]
    },
    selectParentOnChildSelection(name, value) {
      if (value.length === 0) return
      const lastSelectedLogistic = value.slice(-1)[0]
      const deliveryOptions = this.getFieldOptionsByName('delivery_mode')
      const parentMode = deliveryOptions.find(option => option.id === lastSelectedLogistic.parent)
      if (!parentMode) return
      if (!this.form.delivery_mode.some(selected => selected.id === parentMode.id)) {
        this.form.delivery_mode = [...this.form.delivery_mode, parentMode]
      }
    },
    deselectDeliveryMode (name, value) {
      this.form.logistic_type_active = this.form.logistic_type_active.filter((item) => item.parent !== value.id)
    },
    deselectLogisticTypeActive(name, value) {
      const hasChildren = this.form.logistic_type_active.some((item) => item.parent === value.parent)
      if (!hasChildren) {
        this.form.delivery_mode = this.form.delivery_mode.filter((item) => item.id !== value.parent)
      }
    },
    hasOption(options, optionId) {
      return options.some(opt => opt.id === optionId)
    },
    addOptionIfNotExists(options, newOption) {
      if (!this.hasOption(options, newOption.id)) {
        options.push(newOption)
      }
    },
    removeOption(options, optionId) {
      return options.filter(opt => opt.id !== optionId)
    },
    updateFormField(fieldName, option, shouldAdd) {
      if (!shouldAdd) {
        this.form[fieldName] = this.removeOption(this.form[fieldName], option.id)
        return
      }
      if (!this.hasOption(this.form[fieldName], option.id)) {
        this.form[fieldName] = [...this.form[fieldName], option]
      }
    },
    hasRequiredFields() {
      this.deliveryField = this.getFieldByName(this.fields, 'delivery_mode', 'name')
      this.logisticField = this.getFieldByName(this.fields, 'logistic_type_active', 'name')
      return this.deliveryField && this.logisticField
    },
    checkEnableDynamic(name, value) {
      const isMe1 = this.fieldsMeli.some((item) => item.code === 'me1')
      if (!this.hasRequiredFields() || (isMe1 && !value)) return
      const { deliveryMode, logisticType } = this.dynamicShippingConfig
      if (value) {
        this.addOptionIfNotExists(this.deliveryField.options, deliveryMode)
        this.addOptionIfNotExists(this.logisticField.options, logisticType)
      } else {
        this.removeDynamicOptions()
      }
      this.updateFormField('delivery_mode', deliveryMode, value)
      this.updateFormField('logistic_type_active', logisticType, value)
    },
    removeDynamicOptions() {
      if (!this.hasRequiredFields()) return
      const { deliveryMode, logisticType } = this.dynamicShippingConfig
      this.deliveryField.options = this.removeOption(this.deliveryField.options, deliveryMode.id)
      this.logisticField.options = this.removeOption(this.logisticField.options, logisticType.id)
    }
  }
}
</script>
<style>
.title {
  font-size: 30px;
  font-weight: bolder;
}
li::marker {
  color: #044389;
  font-size: 1.6em;
}
.spacing {
  padding: 1rem 2rem;
}
.line {
  border-left: 2px solid #091E3F;
  height:50px;
}
#editForm span form .form-control:disabled {
  background-color: inherit !important;
}
#editForm .vs--disabled .vs__dropdown-toggle, #editForm .vs--disabled .vs__clear, #editForm .vs--disabled .vs__search, #editForm .vs--disabled .vs__open-indicator {
  background-color: #f2f2f8;
}
#editForm .vs--searchable {
  background-color: #fff;
}
#editForm span form div[fieldtype=FieldSelect] {
  background-color: inherit !important;
}
.alert-custom {
  padding: 0.7rem 0.5rem;
  background-color: #E6EEFA;
  border: #D0E2F8 2px solid;
  border-radius: 4px;
  margin-top: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.li--info-text-meli {
  list-style: none;
  position: relative;
  padding-left: 1em;
}

.li--info-text-meli::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0.5em;
  width: 4px;
  height: 4px;
  background-color: #044389;
  border-radius: 50%;
}
button.vs__deselect[title="Deselect [ME1] Mercado Default"] {
  display: none !important;
}
.text-custom-alert-h4 {
  font-size: 10px;
  color: #0169DE;
  font-weight: bold;
  margin-bottom: 0;
}
.text-custom-alert-p {
  font-size: 10px;
  color: #5C5C5C;
  margin-bottom: 0;
  line-height: normal;
}
.img-custom-alert {
  margin-right: 0.5rem;
}
#delivery_mode .dynamic-shipping-enabled button.vs__deselect[title="Deselect Mercado Envíos 1 [M1]"] {
  display: none !important;
}
</style>
